<template>
  <settings-modal class="client-request-status-modal">
    <template slot="heading">{{ modalHeading }}</template>

    <template>
      <p>Setting status as <b>{{ status }}</b> will lock this request, that means you won't be able to write messages within this request.</p>

      <error-alert :error="error" />

      <v-textarea
        id="response"
        v-model="form.reason"
        label="Response to client for completion of request"
        placeholder="Copy response from above or use your own..."
        outline
        auto-grow
        :counter="1000"
        :disabled="loading"
        :error-messages="getValidationErrorMessage('reason')"
      />
    </template>

    <template slot="actions">
      <v-btn
        id="confirm-request-status"
        color="primary"
        medium
        flat
        :disabled="!isFormFilled || loading"
        @click="onConfirmButtonClick"
      >{{ confirmButtonText }}</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="closeModal"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import REASONS from '@/assets/data/client-request-reasons'

  // Constants
  import { REQUEST_STATUSES } from '@/store/clientRequests'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import ClientRequestApi from '@/services/Api/ClientRequestApi'

  // Events
  import { EVENT_CLIENT_REQUEST_UPDATE } from '@/events/clientRequests'

  // Mixins
  import form from '@/mixins/form'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'ClientRequestStatusModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        REQUEST_STATUSES,
        form: { reason: null },
        requiredFields: ['reason'],
        closeClientRequestApiRequest: new ApiRequest(ClientRequestApi.close)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      requestSeq () {
        return this.modal.data.requestSeq
      },
      profileId () {
        return this.modal.data.profileId
      },
      locale () {
        return this.modal.data.locale
      },
      status () {
        return this.modal.data.status
      },
      modalHeading () {
        return this.modal.data.heading
      },
      confirmButtonText () {
        return this.modal.data.confirmButtonText
      },
      loading () {
        return this.closeClientRequestApiRequest.loading
      },
      error () {
        return this.closeClientRequestApiRequest.error
      }
    },
    created () {
      this.setFieldValue('reason', this.status === REQUEST_STATUSES.CANCELED
        ? REASONS['cancel-message'][this.locale]
        : REASONS['done-message'][this.locale]
      )
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      ...mapActions('clientRequests', ['loadUnreadClientRequestCount']),
      onConfirmButtonClick () {
        const status = this.status
        const { reason } = this.parsedFormInput

        this.closeClientRequest(status, reason)
          .then(this.loadUnreadClientRequestCount)
          .then(() => {
            this.$eventHub.$emit(EVENT_CLIENT_REQUEST_UPDATE)
            this.closeModal()

            setTimeout(() => {
              this.showModal({
                name: 'SuccessFlashModal',
                data: { message: `Status has been successfully changed to&nbsp<b>${status}</b>.` }
              })
            }, 100)
          })
          .catch(() => {})
      },
      closeClientRequest (status, reason) {
        return this.closeClientRequestApiRequest.execute({
          profileId: this.profileId,
          seq: this.requestSeq
        }, { status, reason })
      }
    }
  }
</script>
